// extracted by mini-css-extract-plugin
export var salutation = "salutation-module--salutation--b2f86";